export type InlineToken =
	| { kind: "text"; text: string }
	| { kind: "code"; text: string }
	| { kind: "strong"; text: string }
	| { kind: "link"; text: string; href: string }

// Code spans first so `**` or `[x](y)` inside backticks stays literal.
const INLINE =
	/(`+)([\s\S]+?)\1(?!`)|\*\*([^*\n]+)\*\*|\[([^\]\n]+)\]\(([^)\s]+)\)/g

/** Splits an OpenAPI description (CommonMark) into the inline pieces a reference renders. */
export function tokenizeInlineMarkdown(source: string): InlineToken[] {
	const tokens: InlineToken[] = []
	const pushText = (text: string) => {
		if (!text) return
		const last = tokens.at(-1)
		if (last?.kind === "text") last.text += text
		else tokens.push({ kind: "text", text })
	}
	let cursor = 0
	for (const match of source.matchAll(INLINE)) {
		const index = match.index
		pushText(source.slice(cursor, index))
		cursor = index + match[0].length
		const [, ticks, code, strong, linkText, href] = match
		if (ticks && code !== undefined) {
			// CommonMark strips one space from each side so `` `x` `` can show a backtick.
			const inner =
				code.length > 2 && code.startsWith(" ") && code.endsWith(" ")
					? code.slice(1, -1)
					: code
			tokens.push({ kind: "code", text: inner })
		} else if (strong !== undefined) {
			tokens.push({ kind: "strong", text: strong })
		} else if (linkText !== undefined && href !== undefined) {
			if (isSafeHref(href)) tokens.push({ kind: "link", text: linkText, href })
			else pushText(linkText)
		}
	}
	pushText(source.slice(cursor))
	return tokens
}

function isSafeHref(href: string): boolean {
	return /^(https?:|mailto:|\/|#)/i.test(href)
}
